import { useDYMainStore } from "~~/modules/nuxt3-module-doyac/stores/main"
import {useDYAdminMainStore} from "~/modules/nuxt3-module-admin-doyac/stores/main";

// 페이지 이동 시 로딩 UI를 노출시키기 위한 전역 미들웨어. 여기서는 로딩 상태로 변경만 하고 해제하지는 못하므로
// 반드시 각 페이지에서 로딩 상태를 해제해야 한다. `DYPage` 컴퍼넌트에서 로딩을 해제하도록 되어 있으므로 모든
// 페이지 컴퍼넌트는 반드시 `DYPage` 컴퍼넌트를 사용해야 한다.
export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()
  if (process.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) return

  const fromKey = typeof from.meta.key === 'function' ? from.meta.key(from) : from.meta.key
  const toKey = typeof to.meta.key === 'function' ? to.meta.key(to) : to.meta.key

  // 각 라우트의 key가 동일하다면 페이지가 전환된다는 뜻이 아니므로 아무것도 하지 않아야 함. 기존에는 해시 체크까지
  // 했으나 key만 비교해도 충분함.
  if (toKey === fromKey) {
    return
  }

  const mainStore = useDYMainStore()
  mainStore.isLoading = true
  mainStore.isRouteChanging = true
  mainStore.lastScrollY = window.scrollY

  const adminMainStore = useDYAdminMainStore()
  adminMainStore.pageHelpMemoNavSettings.isMainOpened = false
  adminMainStore.pageHelpMemoNavSettings.isSectionOpened = false
})